import { Component, ElementRef, Input, OnInit, Output, Renderer2, ViewChild, AfterViewInit, OnDestroy, ChangeDetectorRef, ChangeDetectionStrategy } from '@angular/core';
import { AbstractControl, UntypedFormGroup, ValidationErrors } from '@angular/forms';
import { EventEmitter } from '@angular/core';
import { DhlFormControlLocation } from '../../models/dhl-form-control-location';
import { Subject, Subscription } from 'rxjs';
import { debounceTime } from 'rxjs/operators';
import { CommonConfig } from 'src/app/common/configuration/common.config';
import { APP_Constants } from 'src/app/app.constant';
import { Modal } from 'src/app/common/modal/modal';
import { ModalService } from 'src/app/common/modal/modal.service';
import { AppService } from 'src/app/app.service';
import { ErrorsConfig } from 'src/app/common/configuration/errors.config';
import { DhlFormControlEvent } from '../../models/dhl-form-control-event';
import { DhlFormControlEventData } from '../../models/dhl-form-control-event-data';
import { DomEventService } from 'src/app/common/dom-event/dom-event.service';
import  {Constant}  from '../../../constants/constants';
import {TranslateService} from '@ngx-translate/core';
import { AlphaService } from 'src/app/app-business-object-module/alpha.service';
import { DhlFormControlAutocomplete } from '../../models/dhl-form-control-autocomplete';


@Component({
  selector: 'app-form-field-location-autocomplete-v2',
  templateUrl: './form-field-location-autocomplete-v2.component.html',
  // styleUrls: ['./form-field-location-autocomplete-v2.component.scss'],
  // host: {
  //   "(document:keyup)": "onWindowClick($event)",
  //   "(document:keyup.Tab)": "onWindowClick($event)",
  //   "(document:click)": "onWindowClick($event)",
  // }
  styleUrls: ['./form-field-location-autocomplete-v2.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false})
export class FormFieldLocationAutocompleteV2Component implements OnInit, AfterViewInit, OnDestroy {

  @Input() configData: DhlFormControlLocation;
  @Input() frmGroup: UntypedFormGroup;

  @Input() fieldMetadata;
  @Output() fieldAction = new EventEmitter();
  @Output() controlValue = new EventEmitter();

  @ViewChild('formControl', {static: true, read: ElementRef}) formControl: ElementRef;
  @ViewChild('inputEle',{static: true, read: ElementRef}) inputEle: ElementRef;
  enum=Constant;
  placeholder: string = '';
  validationType: string = '';
  fieldType: string = '';
  fieldIcon: string = '';
  editField: boolean;
  isLoading: boolean;
  templateData: any;
  selfServiceConfig: boolean = false;

  pickerToggle: boolean = false;

  // seach-com code
  public suggestionList: any[];
  private searchTerms = new Subject<any>();
  suggestion: boolean;
  public selectedItems: Array<any>;
  typing = false;
  searchStr = "";
  selection: string;
  noItemFound: boolean = false;
  noItemFoundError; selectFromListError;
  autoCompleteMetaData: DhlFormControlAutocomplete;
  // make api call vars
  progressBar = false;
  color: String = 'primary';
  mode: String = 'indeterminate';
  locationIdToBeExcluded = '';
  mapUrl: String = '';
  locationIcon;
  locationList = [];
  addNewLocation = false;
  isOpenAddLocationPoup = false;
  isCancelClicked=false;
  dataAvailable = false;
  clickEventSubscription: Subscription;
  keyUpEventSubscription: Subscription;
  keyUpTabEventSubscription: Subscription;
  locationInactiveError;
  orderFormSubmitted: any;
  orderForm: any;

  constructor(private _eref: ElementRef, private renderer: Renderer2, private modalService: ModalService, private appService: AppService, private apiService: AppService,public translate: TranslateService, private domEventService: DomEventService, private changeDetector: ChangeDetectorRef, private alphaService : AlphaService) {

    this.locationList = [];
    this.suggestion = true;
  }

  ngOnInit() {
    if(this.configData.customFormFlag){
      this.selfServiceConfig = false;
    }
    else if(sessionStorage.getItem('isSelfServiceConfig'))
    {
      this.selfServiceConfig = true;
    }
    this.fieldType = this.fieldMetadata ? this.fieldMetadata.fieldType : 'search';
    this.fieldIcon = this.fieldMetadata ? this.fieldMetadata.fieldIcon : null;
    this.searchStr = this.frmGroup.get(this.configData.name).value;
    this.toggleDisable(this.configData['disabled']);
    if (this.configData.validation.length)
      this.fieldValueValidation(this.configData.validation);

      this.autoCompleteMetaData = new DhlFormControlAutocomplete(this.configData);
    // fix it in simpler way
    this.appService.events$.forEach(event => {
      if (event) {
        if (!(Object.keys(event).length === 0 && event.constructor === Object)) {
          if (event.location === 'reset') {
            if (this.configData.name === 'origin') {
              let list = localStorage.getItem('mostUsedOriginLocations');
              if (list)
                this.locationList = JSON.parse(list);
                this.dataAvailable = this.locationList.length ? true : false;
            } else {

              let list = localStorage.getItem('mostUsedDestinationLocations');
              if (list)
                this.locationList = JSON.parse(list);
                this.dataAvailable = this.locationList.length ? true : false;
            }
          }
        }
      }
    })

    this.searchTerms.pipe(debounceTime(CommonConfig.LOCATION_SEARCH_TIMEOUT))
      .subscribe(term => {
        this.makeapicall(term);
        console.log(term);
      });
    this.noItemFound = false;
    if (!this.frmGroup.get(this.configData.name)['itemArray'])
      this.frmGroup.get(this.configData.name)['itemArray'] = [];
    if(this.frmGroup.get(this.configData.name).value){
      this.frmGroup.get(this.configData.name)['itemArray'].push(
        this.frmGroup.get(this.configData.name).value
      )
    }

    this.noItemFoundError = ErrorsConfig.autocomplete.notFound;
    this.selectFromListError = ErrorsConfig.autocomplete.selectFromList;
    this.fetchMostUsedLocations();
    if (this.configData['editable'] === false) {
      this.frmGroup.get(this.configData.name).disable();
    }
    this.configData.validation.forEach(valid => {
      let check = valid.split('-');
      if (check[0] === "NotEqualTo") {
        let name = check[1] + 'Id';
        if (check[2] && this.frmGroup.parent['componentType'] == 'WRAPPER') {
          let nextField = this.frmGroup.parent.parent.get(check[2])['controls'][0].get(name);
          this.locationIdToBeExcluded = nextField.value;
        } else {
          this.locationIdToBeExcluded = this.frmGroup.get(name)?.value;
        }
      }

    });
    if (localStorage.getItem('templateName') === 'orderViewEdit' || localStorage.getItem('templateName') === 'airbusOrderView' || localStorage.getItem('templateName') === "releaseOrderViewEdit" || localStorage.getItem('templateName') === "releaseOrder" || (localStorage.getItem('templateName') === "orderEntry" && localStorage.getItem('originMapUrl') && localStorage.getItem('destMapUrl'))) {
      //this.frmGroup.get(this.configData.name)['itemArray'].push(this.frmGroup.get(this.configData.name).value);
      if (this.configData.name === 'origin') {
        this.mapUrl = localStorage.getItem('originMapUrl');
      } else if (this.configData.name === 'destination') {
        this.mapUrl = localStorage.getItem('destMapUrl');
      } else if (this.configData.name === 'source') {
        this.mapUrl = localStorage.getItem('originMapUrl');
      }
    }


    this.frmGroup.get(this.configData.name).valueChanges.subscribe((value) => {
      if (!value) {
        this.frmGroup.get(this.configData.name)['secondaryText'] = '';
        this.noItemFound = false;
        if (this.configData['relatedColumns'] && this.configData['relatedColumns'].length) {
          this.configData['relatedColumns'].forEach(ele => {
            this.frmGroup.get(ele.value).setValue("");
          });
        }
      }
    })
    this.setDefaultData();
    this.clickEventSubscription = this.domEventService.click.subscribe((e: MouseEvent) => this.onWindowClick(e));
    this.keyUpEventSubscription = this.domEventService.keyUp.subscribe((e: KeyboardEvent) => this.onWindowClick(e));
    this.keyUpTabEventSubscription = this.domEventService.keyUpTab.subscribe((e: KeyboardEvent) => this.onWindowClick(e));
    if(localStorage.getItem('templateName') === 'releaseOrderWithStatus' ){
      let isDraftOrder = JSON.parse(localStorage.getItem("menuPages"));
      let selectedPoData = localStorage.getItem("selectedPoLines") || null;
      let selectedPoLines = selectedPoData && JSON.parse(selectedPoData)[0] || [];
      if (selectedPoData && isDraftOrder && isDraftOrder.indexOf("DRAFT_ORDER") > -1) {
        let locationObj;
        if (this.configData.name === "destination") {
          locationObj = {
            locationId: selectedPoLines['OBLINE_SHIPTO_ID'],
            locationName: selectedPoLines['OBLINE_SHIPTO_NAME'],
            addressLine: selectedPoLines['OBLINE_SHIPTO_ADDRESS_LINE_1'],
            city: selectedPoLines['OBLINE_SHIPTO_CITY'],
            postalCode: selectedPoLines['OBLINE_SHIPTO_POSTALCODE'],
            countryCode: selectedPoLines['OBLINE_SHIPTO_COUNTRY'],
            latitude: selectedPoLines['OBLINE_SHIPTO_LAT'],
            longitude: selectedPoLines['OBLINE_SHIPTO_LON'],
            provinceCode: selectedPoLines['OBLINE_SHIPTO_PROVINCECODE'],
            domainName: selectedPoLines[''],
            contactXid: selectedPoLines['']
          };
        } else if (this.configData.name === "source") {
          locationObj = {
            locationId: selectedPoLines['OBLINE_SHIPFROM_ID'],
            locationName: selectedPoLines['OBLINE_SHIPFROM_NAME'],
            addressLine: selectedPoLines['OBLINE_SHIPFROM_ADDRESS_LINE_1'],
            city: selectedPoLines['OBLINE_SHIPFROM_CITY'],
            postalCode: selectedPoLines['OBLINE_SHIPFROM_POSTALCODE'],
            countryCode: selectedPoLines['OBLINE_SHIPFROM_COUNTRY'],
            latitude: selectedPoLines['OBLINE_SHIPFROM_LAT'],
            longitude: selectedPoLines['OBLINE_SHIPFROM_LON'],
            provinceCode: selectedPoLines['OBLINE_SHIPFROM_PROVINCECODE'],
            domainName: selectedPoLines[''],
            contactXid: selectedPoLines['']
          };
        } else if (this.configData.name === "origin") {
          locationObj = {
            locationId: selectedPoLines['OBLINE_SHIPFROM_ID'],
            locationName: selectedPoLines['OBLINE_SHIPFROM_NAME'],
            addressLine: selectedPoLines['OBLINE_SHIPFROM_ADDRESS_LINE_1'],
            city: selectedPoLines['OBLINE_SHIPFROM_CITY'],
            postalCode: selectedPoLines['OBLINE_SHIPFROM_POSTALCODE'],
            countryCode: selectedPoLines['OBLINE_SHIPFROM_COUNTRY'],
            latitude: selectedPoLines['OBLINE_SHIPFROM_LAT'],
            longitude: selectedPoLines['OBLINE_SHIPFROM_LON'],
            provinceCode: selectedPoLines['OBLINE_SHIPFROM_PROVINCECODE'],
            domainName: selectedPoLines[''],
            contactXid: selectedPoLines['']
          };
        }

        console.log(selectedPoLines, "<=====selectedPoLines")
  
        this.locationDateSave(locationObj);
      }
     } 
     this.alphaService.checkEditAccess(this.configData, this.frmGroup); 
  }

  ngAfterViewChecked() {
    let templtName = localStorage.getItem('templateName');
    if (templtName === "releaseOrder") {
      if (this.configData.name === 'destination') {
        this.mapUrl = localStorage.getItem('destMapUrl');
      }
      else if (this.configData.name === 'source') {
        this.mapUrl = localStorage.getItem('originMapUrl');
      }
      else if (this.configData.name === 'origin') {
        this.mapUrl = localStorage.getItem('originMapUrl');
      }
    }
  }

  setDefaultData() {
    let locationData = {}
    if (this.configData['relatedColumns'] && this.configData['relatedColumns'].length) {
      this.configData['relatedColumns'].forEach(ele => {
        let value = this.frmGroup.get(ele.value).value;
        if (value) {
          locationData[ele.key] = value;
        }
      });
      if (Object.values(locationData).length)
        this.selectedLocation(null, locationData);
    }
  }

  selectedLocation($event, data) {
    this.noItemFound = false;
    let address = '';
    let mapAddress = '';
    let validateArray = this.configData.hasOwnProperty("secondaryText") && this.configData.hasOwnProperty("affectedColumnsV2") && this.configData['secondaryText']?.length > 0 && this.configData['affectedColumnsV2']?.length > 0;
    if (validateArray) {
      this.configData['secondaryText'].forEach((fieldName, i) => {
        address += data[fieldName] + ((this.configData['secondaryText']?.length !== (i + 1)) ? ", " : '');
        mapAddress += data[fieldName] + ((this.configData['secondaryText']?.length !== (i + 1)) ? ",-" : '');
      })
      this.frmGroup.get(this.configData.name)['secondaryText'] = address;
    } else {
      data?.addressLine?.split(' ')?.forEach(a => {
        address += '-' + a;
      });
      this.frmGroup.get(this.configData.name)['secondaryText'] = data.addressLine + "," + data.city + ',' + data.provinceCode + ',' + data.postalCode;
    }
    address = address.substr(1, address.length);
    
    if (validateArray && this.configData.linkToMap) {
      this.mapUrl = "https://wego.here.com/directions/mix/" + mapAddress + '?map=' + data.latitude + ',' + data.longitude + ',15,normal';
    } else {
      this.mapUrl = "https://wego.here.com/directions/mix//" + address + ",-" + data.city + ',-' + data.provinceCode + ',-' + data.postalCode + ',-' + data.countryCode + '?map=' + data.latitude + ',' + data.longitude + ',15,normal';
    }
    if (validateArray) {
      this.configData['affectedColumnsV2'].forEach((fieldName)=>{
        this.frmGroup.get(fieldName['configName']).setValue(data[fieldName['configNameOTM']]);
      })
    } else  { 
      this.frmGroup.get(this.configData.name + "Id").setValue(data.locationId);
    }
    if (this.configData['relatedColumns'] && this.configData['relatedColumns'].length) {
      this.configData['relatedColumns'].forEach(col => {
        this.frmGroup.get(col.value).setValue(data[col.key]);
      });
    }
    this.locationList = [];
    if (this.configData.name === 'destination' || this.configData.name === 'destLocation') {
      this.appService.setDestinationUsedLocation(data);
    } else {
      this.appService.setOriginUsedLocation(data);
    }
    this.locationDateSave(data)
  }
  locationDateSave = (data) =>{
    //Store The data for future refrence 
    let isDraftOrder = JSON.parse(localStorage.getItem("menuPages"));
    if (isDraftOrder && isDraftOrder.indexOf("DRAFT_ORDER") > -1) {
      let localStorageLocation = localStorage.getItem("selectedLocation");
      let selectedLocation = localStorageLocation ? JSON.parse(localStorageLocation) : {};
      selectedLocation[this.configData.name] = data;
      let storeObj = JSON.stringify(selectedLocation);
      localStorage.setItem("selectedLocation", storeObj);
    } else {
      localStorage.removeItem("selectedLocation");
    }
    //End
  }

  fetchMostUsedLocations() {
    let preferredLocation = this.configData.preferredLocation;

    if (preferredLocation && preferredLocation.apiUrl) {
      let url = preferredLocation.apiUrl + localStorage.getItem('userName') + '&customerCode=' +
        localStorage.getItem('customerCode') + '&preferenceType=' + preferredLocation.preferenceType + '&action=' + preferredLocation.action;;
      this.appService.makeHttpGetRequest(url).subscribe((data: any) => {
        console.log(data);
        if (data) {
          if (data[0] !== null) {
            if ((this.frmGroup.get(this.configData.name).value === '' || this.frmGroup.get(this.configData.name).value === null)) {
              this.locationList = data;
              this.locationIcon = 'history';
              this.dataAvailable = this.locationList.length ? true : false;
            }
            if (this.configData.name === 'origin') {
              localStorage.setItem('mostUsedOriginLocations', JSON.stringify(data));
            } else {
              localStorage.setItem('mostUsedDestinationLocations', JSON.stringify(data));
            }
          }
        }
      }, err => {
        console.log(err);
      })
    }
  }

  getFormStatus(e) {
    this.orderFormSubmitted = e;
  }

  getForm(e) {
    this.orderForm = e;
  }

  normalView() {
    throw new Error('Method not implemented.');
  }

  ngAfterViewInit() {
    this.placeholder = this.configData.placeHolder
    let templtName = localStorage.getItem('templateName');
    let location = JSON.parse(localStorage.getItem("selectedLocation"));
    if (templtName === "orderViewEdit" || templtName === "releaseOrderViewEdit" || templtName === "releaseOrder") {
      // this.frmGroup.get(this.configData.name)['itemArray'].push(this.frmGroup.get(this.configData.name).value);
    }
    if(this.frmGroup.get(this.configData.name).value){
      this.frmGroup.get(this.configData.name).updateValueAndValidity();
    }
    this.searchStr = this.frmGroup.get(this.configData.name).value;

    if (this.frmGroup.get(this.configData.name).value && location && location[this.configData.name] && this.configData?.events?.find(e => e.event === "VALIDATE_WHEN_AUTOCOMPLETE_SELECTED")) {
      location[this.configData.name]['primaryValue'] = this.frmGroup.get(this.configData.name).value;
      this.selectItem("", location[this.configData.name]);
    }
    if (this.frmGroup.get(this.configData.name).value &&  this.configData?.events?.find(e => e.event === "VALIDATE_WHEN_AUTOCOMPLETE_SELECTED")) {
      this.onCommonEventHander('VALIDATE_WHEN_AUTOCOMPLETE_SELECTED', this.configData?.events)
    }

    let filterObj = this.alphaService.getFilteredObject("setFiltersValues");
    if (filterObj && filterObj[this.configData.name]) { 
      this.selectItem("", filterObj[this.configData.name]);
    }
    this.validateLocationIsActive();
  }


  fieldValueValidation(validations) {
    validations.forEach((validataion: string | any) => {
      let element = (typeof validataion == "object" ? validataion.name : validataion);
      if (element === 'hidden') {
        if (!(this.frmGroup.get(this.configData.name)['hidden'] === false)) {
          this.frmGroup.get(this.configData.name)['hidden'] = true;
          this.configData.required = false;
          this.frmGroup.get(this.configData.name).clearValidators();
          this.frmGroup.get(this.configData.name).updateValueAndValidity();
        }
      }
    }, this);
  }

  toggleDisable(disabled) {
    if (disabled === true) {
      this.frmGroup.get(this.configData.name).disable();
      this.formControl.nativeElement.parentElement.classList.add('disabled');
    } else {
      this.frmGroup.get(this.configData.name).enable();
      this.formControl.nativeElement.parentElement.classList.remove('disabled');
    }
  }

  popFieldAction(e) {
    this.fieldAction.emit(e);
  }

  onWindowClick(event) {
    if (!this._eref.nativeElement.contains(event.target)) {
      // if(!this.isOpenAddLocationPoup && this.isCancelClicked)
      // {
      //   this.addNewLocation = true;
      //   this.isCancelClicked=false;
      // }
      if (!this.isOpenAddLocationPoup)
        this.addNewLocation = false;
      this.typing = false;
      let selection: any = this.frmGroup.get(this.configData.name).value;
      if (selection !== '') {
        if (this.frmGroup.get(this.configData.name)['itemArray'] && this.frmGroup.get(this.configData.name)['itemArray'].indexOf(selection) < 0) {
          this.frmGroup.get(this.configData.name).setErrors({ 'selectFromList': true });
        }
      }
    }
  }

  controlValueChange(e) {
    console.log('change---->', e.target.value.trim())
  }

  setOnFocus($event) {
    if ($event.target.value.trim().length >= 3) {
      this.typing = true;
      this.dataAvailable = this.locationList.length ? true : false;
    }
  }

  onkeyupHandler($event) {
    if ($event.currentTarget.value === '') {
      this.locationIcon = 'history';
      this.frmGroup.get(this.configData.name + "Id").setValue('');

      if (this.configData.name === 'origin' || this.configData.name === 'sourceLocation') {
        let list = localStorage.getItem('mostUsedOriginLocations');
        if (list)
          this.locationList = JSON.parse(list);
        else{
          this.locationList = [];
          this.dataAvailable = false;
        }
      } else {

        let list = localStorage.getItem('mostUsedDestinationLocations');
        if (list)
          this.locationList = JSON.parse(list);
        else{
          this.dataAvailable = false;
          this.locationList = [];
        }
      }
      this.dataAvailable = this.locationList.length ? true : false;
    }
    if (this.frmGroup.get(this.configData.name).value !== '') {
      if (this.frmGroup.get(this.configData.name)['itemArray'] && this.frmGroup.get(this.configData.name)['itemArray'].indexOf(this.frmGroup.get(this.configData.name).value) > -1 ||
        (this.locationList.length > 0 && this.selection === this.frmGroup.get(this.configData.name).value)) {
        return;
      } else {
        this.selection = this.frmGroup.get(this.configData.name).value;
      }
    }
    this.configData.validation.forEach(check => {
      let validationCheck = check.split('-');
      if (validationCheck[0] === 'NotEqualTo') {
        if (validationCheck[2] && this.frmGroup.parent['componentType'] == 'WRAPPER') {
          let nextField = this.frmGroup.parent.parent.get(validationCheck[2])['controls'][0].get(validationCheck[1] + 'Id');
          this.locationIdToBeExcluded = nextField.value;
        } else{
          if (this.configData.name === 'source_location_id' || this.configData.name === 'dest_location_id') {
            this.locationIdToBeExcluded = this.frmGroup.get(validationCheck[1]).value;
          }
          else {
            this.locationIdToBeExcluded = this.frmGroup.get(validationCheck[1] + 'Id')?.value;
          }
        }
      }
    })

    this.noItemFound = false;
    this.frmGroup.get(this.configData.name)['secondaryText'] = '';
    this.configData.hintText = '';
    let searchText = $event.currentTarget.value;
    let minSearchChar = 3;
    if(this.configData['minSearchChar']) {
      minSearchChar = this.configData['minSearchChar'];
    }
    if (searchText.length >= minSearchChar && searchText != null) {
      this.locationList = [];
      this.dataAvailable = false;
      console.log(this.frmGroup.get(this.configData.name).errors)
      this.searchTerms.next(searchText);
      this.typing = true;
    } else {
      this.typing = false;
      this.locationList = [];
      this.dataAvailable = false;
      this.frmGroup.get(this.configData.name)['itemArray'] = [];
    }
    //Remove Saved location from Localstorage after select any location
    let isDraftOrder = JSON.parse(localStorage.getItem("menuPages"));
    if(isDraftOrder && isDraftOrder.indexOf("DRAFT_ORDER") > 0){
      let selectedLocationJson = localStorage.getItem("selectedLocation");
      if(selectedLocationJson){
        let selectedLocation = JSON.parse(selectedLocationJson);
        if(selectedLocation[this.configData.name]) {
          delete selectedLocation[this.configData.name];
          localStorage.setItem("selectedLocation", JSON.stringify(selectedLocation));
        }
      }
    }
    //End
  }

  selectItem($event, data, ignoreResetEvents = false) {
    this.noItemFound = false;
    let address = '';
    let mapAddress = '';
    // po line item secondary text
    let validateArray = this.configData.hasOwnProperty("secondaryText") && this.configData.hasOwnProperty("affectedColumnsV2") && this.configData['secondaryText']?.length > 0 && this.configData['affectedColumnsV2']?.length > 0;
    if (validateArray) {
      this.configData['secondaryText'].forEach((fieldName, i)=>{
        address += data[fieldName] + ((this.configData['secondaryText']?.length !== (i+1)) ? ", " : '');
        mapAddress += data[fieldName] + ((this.configData['secondaryText']?.length !== (i+1)) ? ",-" : '');
      })
      this.frmGroup.get(this.configData.name)['secondaryText'] = address;
    }
    else if (this.configData['secondaryText'] && this.configData['secondaryText']?.length > 0) {
      data?.addressLine?.split(' ')?.forEach(a => {
        address += '-' + a;
      })
      this.configData.hintText = 'true';
      this.frmGroup.get(this.configData.name)['secondaryText'] = data.addressLine + "," + data.city + ',' + data.provinceCode + ',' + data.postalCode;
    }
    if(validateArray && this.configData.linkToMap){
      this.mapUrl = "https://wego.here.com/directions/mix/" + mapAddress +'?map=' + data.latitude + ',' + data.longitude + ',15,normal';
    } else {
    this.mapUrl = "https://wego.here.com/directions/mix//" + address + ",-" + data.city + ',-' + data.provinceCode + ',-' + data.postalCode + ',-' + data.countryCode + '?map=' + data.latitude + ',' + data.longitude + ',15,normal';
    }
    this.frmGroup.get(this.configData.name).setValue(data.primaryValue);
    if (this.configData.name === 'source_location_id' || this.configData.name === 'dest_location_id') {
      this.frmGroup.get(this.configData.name).setValue(data.locationId);
    } else if (validateArray) {
      this.configData['affectedColumnsV2'].forEach((fieldName)=>{
        this.frmGroup.get(fieldName['configName']).setValue(data[fieldName['configNameOTM']]);
      })
    } else  {
      this.frmGroup.get(this.configData.name + "Id").setValue(data.locationId);
    }
    //this.locationList = [];
    this.dataAvailable = false;
    this.typing  = false;
    if (this.configData.name === 'destination' || this.configData.name === 'destLocation') {
      this.appService.setDestinationUsedLocation(data);
    } else {
      this.appService.setOriginUsedLocation(data);
    }
    this.selectedLocation($event, data);
    this.onCommonEventHander('VALIDATE_WHEN_AUTOCOMPLETE_SELECTED', $event);
    this.alphaService.manageAffectedColumn(this.configData, this.frmGroup, data, ignoreResetEvents);

    let filterObj = this.alphaService.getFilteredObject("setFiltersValues");
    if (filterObj) {
      this.frmGroup.get(this.configData.name)['itemArray'] = [this.frmGroup.get(this.configData.name).value];
      this.alphaService.createLocationObj(this.configData.name, data);
    }

    if (this.frmGroup.get(this.configData.name)?.hasValidator(this.locationInactiveValidator)) {
      this.frmGroup.get(this.configData.name).removeValidators(this.locationInactiveValidator);
      this.frmGroup.get(this.configData.name).updateValueAndValidity({ emitEvent: false });
    }
  }
  appendAdditionalQueryParams(url: string) {
    if (this.autoCompleteMetaData['qparams'] &&
      this.autoCompleteMetaData.qparams.hasOwnProperty('addqparams') &&
      this.autoCompleteMetaData.qparams.addqparams &&
      this.autoCompleteMetaData.qparams.hasOwnProperty('qparamlist') &&
      Array.isArray(this.autoCompleteMetaData.qparams.qparamlist) &&
      this.autoCompleteMetaData.qparams.qparamlist.length > 0) {
      this.autoCompleteMetaData.qparams.qparamlist.forEach(qparam => {
        let qValu = qparam['qval'];
        if(
          qparam.hasOwnProperty('qType') && 
          qparam.qType === "form" && 
          this.appService._components[qparam['qval']] && 
          this.appService._components[qparam['qval']].frmGroup && 
          this.appService._components[qparam['qval']].frmGroup.get(qparam['qval']) && 
          this.appService._components[qparam['qval']].frmGroup.get(qparam['qval']).value){
            qValu = this.appService._components[qparam['qval']].frmGroup.get(qparam['qval']).value;
        }
        url += '&' + qparam['qkey'] + '=' + qValu;
      });
    }
    return url;
  }
  makeapicall(searchText) {
    this.progressBar = true;
    if(this.changeDetector) this.changeDetector.detectChanges();
    this.addNewLocation = false;
    let url = '';
    if (this.configData['url']) {
      this.frmGroup.get(this.configData.name)['itemArray'] = [];
      if (localStorage.getItem('templateName') === 'orderViewEdit' || localStorage.getItem('templateName') === "releaseOrder") {
        this.frmGroup.get(this.configData.name)['itemArray'].push(this.frmGroup.get(this.configData.name).value);
        if (this.configData.name === 'origin') {
          this.mapUrl = localStorage.getItem('originMapUrl');
        } else if (this.configData.name === 'destination') {
          this.mapUrl = localStorage.getItem('destMapUrl');
        }
      }
      let apiUrl = this.configData.hasOwnProperty('apiUrl') && this.configData['apiUrl'] != '' ? this.configData['apiUrl'] : APP_Constants.LOCATION_SEARCH_URL;
      url = apiUrl + localStorage.getItem('customerCode') +
        '&userId=' + localStorage.getItem('userName') +
        "&searchString=" + encodeURIComponent(searchText.toUpperCase()) +
        '&locationIdToBeExcluded=' + this.locationIdToBeExcluded;
    }
    url = this.appendAdditionalQueryParams(url);
    if (this.configData['otherApiParam']) {
      url += '&action=' + this.configData['otherApiParam'];
    }
    this.appService.makeHttpGetRequest(url)
      .subscribe(data => {
        this.progressBar = false;

        if (data['message'].statusCode === APP_Constants.SUCCESS_CODE) {
          if (this.configData['responseData']) {
            this.locationList = data[this.configData['responseData']];
            this.locationList.map((loc) => {
              const primaryText = this.getPrimaryText(loc);
              this.frmGroup.get(this.configData.name)['itemArray'].push(primaryText);
              loc['primaryValue'] = primaryText;
            })
          }
          else {
            this.locationList = data['items'];
            this.locationList.map((item) => {
              this.frmGroup.get(this.configData.name)['itemArray'].push(item.itemId + ' - ' + item.itemName);
            })
          }
          this.dataAvailable = this.locationList.length ? true : false;
        } else {
          if (this.configData['addNewLocation']) {
            this.addNewLocation = true;
          }
          this.noItemFound = true;
          this.frmGroup.get(this.configData.name)['itemArray'] = [];
          this.locationList = [];
          this.dataAvailable = false;
          this.configData.validation.forEach(elem => {
            if (elem === 'Select from list') {
              if (!this.addNewLocation)
                this.frmGroup.get(this.configData.name).setErrors({ 'NoItemFound': { 'message': '' } });
            }
          }, this);
        }
        if(this.changeDetector) this.changeDetector.detectChanges();
      },
        (err) => {
          this.progressBar = false;
          let modal = new Modal({
            action: false, name: 'itemSearch', title: 'Item Search', description: err.message, actionButtonText: ''
          });
          this.modalService.createModalBox(modal, err.status);
          // console.log(err)
        }
      );
  }

  close() {
    this.searchStr = "";
    this.frmGroup.get(this.configData.name).setValue(this.searchStr);
    this.typing = false;
    this.renderer.removeAttribute(this.inputEle.nativeElement, 'placeholder');
    this.renderer.removeClass(this.inputEle.nativeElement.parentElement, 'active');
  }

  AddNewLocation($event) {
    this.isOpenAddLocationPoup = true;
    let event: DhlFormControlEvent | null = this.checkEventExist(this.configData.events, 'ADD_NEW_LOCATION');
    if (event) {
      this.sendToSource(event);
    }
  }

  /** Common Method to check event exist in template */
  checkEventExist(events, eventName): DhlFormControlEvent | null {
    let event = null;
    if (events && Array.isArray(events)) {
      event = events.filter(ele => ele.event == eventName);
      event = (event.length ? event[0] : null);
    }
    return event;
  }

  sendToSource(event: DhlFormControlEvent, row = {}) {
    let eventData: DhlFormControlEventData = {
      event: event.event,
      eventData: event,
      action: event.action,
      name: this.configData.name,
      component: this,
      configData: this.configData,
      data: row,
    }
    this.apiService._commonComponentSubject.next(eventData);
  }

  ngOnDestroy() {
    if (this.clickEventSubscription) {
      this.clickEventSubscription.unsubscribe();
    }
    if (this.keyUpEventSubscription) {
      this.keyUpEventSubscription.unsubscribe();
    }
    if (this.keyUpTabEventSubscription) {
      this.keyUpTabEventSubscription.unsubscribe();
    }
  }

  onCommonEventHander(eventType, value = null) {
    let event: DhlFormControlEvent | null = this.checkEventExist(this.configData.events, eventType);
    let allow = false;
    if(event){
      allow =  (event['eventOnDisable'] === true && this.configData['disabled'] === true) || event['eventOnDisable'] === undefined;
    }
    if (this.frmGroup.get(this.configData.name).valid || allow) {
      if (event) {
        this.sendToSource(event, this.frmGroup.get(this.configData.name).value);
        return
      }
    }
  }

  setDefaultValueOnReset() {
    let location = JSON.parse(localStorage.getItem("selectedLocation"));
    if (this.frmGroup.get(this.configData.name).value && location && location[this.configData.name] && this.configData?.events?.find(e => e.event === "VALIDATE_WHEN_AUTOCOMPLETE_SELECTED")) {
      location[this.configData.name]['primaryValue'] = this.frmGroup.get(this.configData.name).value;
      this.selectItem("", location[this.configData.name]);
    }
  }

  getPrimaryText(item: any) {
    const primaryText = this.configData?.primaryText || [];
    return primaryText.map((key) => item[key]).join(' - ');
  }

  validateLocationIsActive(): void {
    if (!this.getLocationActiveFlag()) {
      return;
    }
    const locationControl = this.frmGroup.get(this.configData.name);
    this.locationInactiveError = this.configData?.['locationInactiveError'];
    if (!locationControl?.hasValidator(this.locationInactiveValidator)) {
      locationControl?.addValidators(this.locationInactiveValidator);
    }
    locationControl?.updateValueAndValidity({ emitEvent: false });
  }

  getLocationActiveFlag(): AbstractControl | null {
    return this.configData['locationActiveStatusField']
      ? this.frmGroup.get(this.configData['locationActiveStatusField'])
      : null;
  }

  locationInactiveValidator = (control: AbstractControl): ValidationErrors | null => {
    return control.value && this.getLocationActiveFlag()?.value === 'N' ? { locationInactive: true } : null;
  }
}
